import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';
import Header from '../../components/header/Header';

import { request, reportErrorToHoneybadger } from '../../helpers/Requests'

import OrganisationName from '../../components/shared/OrganisationName';
import SetTitle from '../../components/shared/SetTitle';

import { formatDate } from '../../utilities/Generic.js'

class PlannedEventsIndex extends Component {
  state = {
    locations: null,
    loaded: false
  };

  backgroundImage(background_image) {
    if (background_image !== null) {
      return (
        `url(${process.env.REACT_APP_ROOT_DOMAIN}/${background_image})`
      );
    }
  }

  backgroundRadial(full_name) {
    let rgbCodes = full_name.split(" ").map(name => this.nameToColor(name))

    if (rgbCodes.length === 1) {
      rgbCodes.push("rgb(255, 255, 255")
    }

    return (
      `radial-gradient(ellipse, ${rgbCodes.join(", ")}`
    )
  }

  mod(number, modulo) {
    // % in JavaScript is technically a "remainder" operator, so if you don't want it to spit out negative numbers you need to do this
    return ((number % modulo) + modulo) % modulo;
  }

  nameToColor(name) {
    let r = 0
    let g = 0
    let b = 0

    for (let i in name) {
      if (i % 3 === 0) {
        r += ((name.charCodeAt(i) - 97) * name.length * 2)
      }
      else if (i % 3 === 1) {
        g += ((name.charCodeAt(i) - 97) * name.length * 2)
      }
      else {
        b += ((name.charCodeAt(i) - 97) * name.length * 2)
      }
    }
    return `rgb(${this.mod(r, 255)}, ${this.mod(g, 255)}, ${this.mod(b, 255)})`
  }

  todaysDate() {
    return formatDate(new Date())
  }

  tomorrowsDate() {
    const date = new Date()
    date.setDate(date.getDate() + 1)

    return formatDate(date)
  }

  renderLocationBox(location) {
    return (
      <Link to={`/appointments/${location.id}`}>
        <div className="widget locations-component full-background" style={{ backgroundImage: this.backgroundImage(location.background_image) }}>
          <div className="fade">
            <h3 className="title">{location.name}</h3>
          </div>
        </div>
      </Link>
    )
  }

  renderHostBox(location, host) {
    return (
      <div className="widget rota-type-component full-background contains-absolute-link" key={host.id} style={{ background: this.backgroundRadial(host.full_name) }}>
        <Link to={`/appointments/${location.id}/day/${this.todaysDate()}/?host_ids=${host.id}`} className="hidden-link absolute-link"/>
        <div className="fade">
          <h3 className="title">{host.full_name}</h3>
          <div>Appointments today: {host.today}</div>
          <Link to={`/appointments/${location.id}/day/${this.tomorrowsDate()}/?host_ids=${host.id}`} className="hidden-link nested-link"><div>Appointments tomorrow: {host.tomorrow}</div></Link>
        </div>
      </div>
    )
  }

  showMore(location) {
    const overFlow = location.hosts.slice(4)

    if (overFlow.length === 1) {
      return this.renderHostBox(location, overFlow[0])
    }

    if (overFlow.length > 1) {
      const host_ids = overFlow.map(host => host.id)
      const names = overFlow.map(host => host.full_name).join(" ")
      const today = overFlow.reduce((sum, host) => sum += host.today, 0)
      const tomorrow = overFlow.reduce((sum, host) => sum += host.tomorrow, 0)

      return (
        <div className="widget rota-type-component full-background contains-absolute-link" style={{ background: this.backgroundRadial(names) }}>
          <Link to={`/appointments/${location.id}/day/${this.todaysDate()}/?host_ids=${host_ids}`} className="hidden-link absolute-link"/>
          <div className="fade">
            <h3 className="title">{overFlow.length} Other Host{overFlow.length > 1 ? "s" : ""}</h3>
            <div>Appointments today: {today}</div>
            <Link to={`/appointments/${location.id}/day/${this.tomorrowsDate()}/?host_ids=${host_ids}`} className="hidden-link nested-link"><div>Appointments tomorrow: {tomorrow}</div></Link>
          </div>
        </div>
      )
    }
  }

  render() {
    const { locations, loaded, unauthorized, error } = this.state;

    if (localStorage.license === "entry") {
      return <Redirect to="/upgrade" />
    }

    if (unauthorized) {
      return <Redirect to="/login"/>
    }

    if (error) {
      return <div>{error.message}</div>;
    }

    if (loaded === false) {
      return (
        <div>
          <SetTitle title={"Appointments"} />
          <Header />

          <div className="main-page">
            <h2 className="page-title bottom-margin">Appointments</h2>
            <OrganisationName />

            <p>Loading ...</p>
          </div>
        </div>
      )
    }

    return (
      <div>
        <SetTitle title={"Appointments"} />
        <Header />

        <div className="main-page">
          <h2 className="page-title bottom-margin">Appointments Home</h2>

          {locations.map((location) => (
            <div className="location-row" key={location.id}>
              {this.renderLocationBox(location)}

              {location.hosts.slice(0, 4).map((host) => (
                this.renderHostBox(location, host)
              ))}

              {this.showMore(location)}
            </div>
          ))}
        </div>

      </div>
    );
  }

  componentDidMount() {
    // normal API fetching stuff
    request('GET', `/v1/a/planned_events/home`, null, () => {this.setState({ unauthorized: true })})
      .then(data => this.setState({ locations: data, loaded: true }))
      .catch(error => {
        reportErrorToHoneybadger(error)

        this.setState({ error, loaded: true })
      })
  }
}

export default PlannedEventsIndex;
